import * as React from 'react';

import ActionBarItem from './ActionBarItem';

import IMPComponent from '../interfaces/IMPComponent';

import styled from 'styled-components';

interface IActionBarProps extends IMPComponent {
  onEdit: () => void;
  onDelete: () => void;
}

const ActionBarContainer = styled.ul`
  align-items: center;
  display: flex;
  fill: ${p => p.theme.color.black};
  justify-content: space-between;
  list-style-type: none;
  margin: 0;
  padding: 0;

  width: 80px;
`;

const ActionBar = ({ onEdit, onDelete }: IActionBarProps) => {
  return (
    <ActionBarContainer>
      <ActionBarItem iconName="edit-icon" action={onEdit} />
      <ActionBarItem iconName="trash-icon" action={onDelete} />
    </ActionBarContainer>
  );
};

export default React.memo(ActionBar);



// WEBPACK FOOTER //
// ./src/components/ActionBar/index.tsx